import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { Route, Router, Switch, Redirect } from 'react-router-dom';

import history from '_app/history';
import { APP_ROUTES } from '_app/routes';
import theme from '_app/theme';

import SingInPage from 'pages/signIn/SingInPage';
import Admin from '_app/Admin';

import ScrollToTop from 'components/ScrollToTop';
import Loader from 'components/Loader';

import 'utils/i18n';

const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Router history={history}>
        <ScrollToTop />
        <Loader />
        <Switch>
          <Route exact path={APP_ROUTES.SIGN_IN}>
            <SingInPage />
          </Route>
          <Admin />
          <Redirect from="*" to={APP_ROUTES.SIGN_IN} />
        </Switch>
      </Router>
    </ChakraProvider>
  );
};

export default App;
